import React from "react";
import styled from "@emotion/styled";
import NavigationItem from "./NavigationItem";
import config from "../../config";
import FadeIn from "../utils/FadeIn";
import { heightBreakpoints, forSize } from "../utils/sizeMixins";

const StyledNavigation = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 90%;
    padding: 1em 2em 1em 2em;

    ${forSize(heightBreakpoints.small, 'down', 'y')} {
        padding: 1em 1em 1em 1em;
    }

    a {
        text-decoration: none;
        color: var(--nav-text-color);
        width: 100%;
        transition: color 0.2s ease-in-out;
    }

    .full-size {
        width: 97%;
        height: inherit;
    }
`;

const Navigation = () => {

    return (
        <StyledNavigation>
            {config.navigation.map((item, index) => (
                <FadeIn
                    key={index}
                    direction="right"
                    distance="-10px"
                    delay={index * 70}
                    className="full-size"
                    childClassName="full-size"
                >
                    <NavigationItem key={index} icon={item.icon} name={item.name} path={item.path} />
                </FadeIn>
            ))}
        </StyledNavigation>
    );
}
export default Navigation;